module.exports = __webpack_public_path__ + "static/assets/5c6533a34175f61a9cab627f671111e1.mp3";